import { useQuery } from '@provision/graphql-client';
import { GET_ENTITY_VIEWER_QUERY } from 'src/graphql/entities/entity-viewer/entity-viewer.operations';
import {
  GetEntityViewerResult,
  GetEntityViewerVars,
} from 'src/graphql/entities/entity-viewer/entity-viewer.types';
import { useEntityViewersSubscription } from './use-entity-viewers-subscription';

export function useEntityViewers(params: GetEntityViewerVars['params']) {
  const { data, loading, client, variables, error, refetch } = useQuery<
    GetEntityViewerResult,
    GetEntityViewerVars
  >(GET_ENTITY_VIEWER_QUERY, {
    variables: { params },
    // fallback reconciliation - 5 mins
    pollInterval: 300000,
    skip: !params?.entity || !params?.entityId,
    context: {
      ttl: 0,
    },
    fetchPolicy: 'network-only',
  });

  useEntityViewersSubscription(client, variables!);

  return {
    items: data?.getEntityViewer.items ?? [],
    ts: data?.getEntityViewer.ts,
    loading,
    error,
    refetch,
  };
}
